import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";

import { z } from "zod";
import { DriverGroupResponse } from "@lib/types/driver_group";

export const driverGroupSchema = z.object({
  name: z.string().min(1, "Name is required"),
  description: z.string().optional(),
  drivers: z.array(z.number()).optional(),
});
export type DriverGroupFormData = z.infer<typeof driverGroupSchema>;

export const createDriverGroup = async (
  createDriverGroupParams: DriverGroupFormData
): Promise<DriverGroupResponse> => {
  const { data } = await axiosClient.post(
    ENDPOINTS.BASE_DRIVER_GROUPS,
    createDriverGroupParams
  );
  return data;
};
export const updateDriverGroup = async ({
  driverGroupId,
  updateDriverGroupParams,
}: {
  driverGroupId: number;
  updateDriverGroupParams: DriverGroupFormData;
}): Promise<DriverGroupResponse> => {
  const { data } = await axiosClient.put(
    `${ENDPOINTS.BASE_DRIVER_GROUPS}/${driverGroupId}`,
    updateDriverGroupParams
  );
  return data;
};
